/**
 * Helper: Loaders
 * -----------------------------------------------------------------------------
 * Store for loader markup
 */
export default {
    ring: '<div class="icon icon__loading-ring"></div>'
}



// WEBPACK FOOTER //
// ./src/resources/scripts/helpers/loaders.js